const POST = async params => {
  try {
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => formData.append(key, value));

    const response = await fetch('support.php', {
      method: 'POST',
      body: formData,
    });

    const json = await response.json();
    return json;
  } catch (error) {
    console.error('Error:', error);
  }
};

export default { POST };
